import React from "react";
import { useAuth } from "@/lib/auth";
import { Navigate } from "react-router-dom";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;

  const handleGoogleSignIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-[#F8F7F5]" data-testid="login-page">
      {/* Left: form */}
      <div className="flex items-center justify-center p-8 md:p-16">
        <div className="w-full max-w-sm">
          <div className="mb-10">
            <div className="uppercase-tiny text-[#1B4332] mb-3">Internal Sales</div>
            <h1 className="font-heading text-4xl leading-tight tracking-tight mb-2">
              Paisley Partnership <br />Outreach Engine
            </h1>
            <p className="text-sm text-gray-600 mt-4 leading-relaxed">
              The internal tool for identifying, qualifying and converting local
              sponsors and advertisers for paisley.org.uk.
            </p>
          </div>

          <button
            onClick={handleGoogleSignIn}
            data-testid="google-signin-button"
            className="w-full bg-[#101C26] text-white text-sm py-3 rounded-sm hover:bg-[#1B4332] transition-colors duration-200 font-medium"
          >
            Continue with Google
          </button>

          <div className="mt-6 text-xs text-gray-500 leading-relaxed">
            Access is limited to the Paisley partnerships team. Contact your admin if you
            need to be added to the allowlist.
          </div>

          <div className="mt-10 border-t border-gray-200 pt-6 text-xs text-gray-500">
            <div className="uppercase-tiny mb-2">Tiers on offer</div>
            <div className="grid grid-cols-4 gap-2 text-center">
              {[
                { n: "Bronze", p: "£149", c: "tier-bronze" },
                { n: "Silver", p: "£249", c: "tier-silver" },
                { n: "Gold", p: "£399", c: "tier-gold" },
                { n: "Platinum", p: "£699", c: "tier-platinum" },
              ].map((t) => (
                <div key={t.n} className="border border-gray-200 py-3 rounded-sm bg-white">
                  <div className={`font-heading text-sm ${t.c}`}>{t.n}</div>
                  <div className="text-[11px] text-gray-500 mt-1">{t.p}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Right: imagery */}
      <div
        className="hidden md:block relative bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1736771676171-fe56bb0811a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxzY290dGlzaCUyMGhpZ2hsYW5kcyUyMGZvZyUyMHRleHR1cmV8ZW58MHx8fHwxNzgzNjM1ODA1fDA&ixlib=rb-4.1.0&q=85')",
        }}
        data-testid="login-hero-image"
      >
        <div className="absolute inset-0 bg-gradient-to-tr from-[#101C26]/60 via-transparent to-transparent" />
        <div className="absolute bottom-8 left-8 right-8 text-white">
          <div className="uppercase-tiny opacity-70">Renfrewshire · Scotland</div>
          <div className="font-heading text-3xl mt-1 leading-tight">
            Turn local business goodwill<br />into sustained partnership revenue.
          </div>
        </div>
      </div>
    </div>
  );
}
